import { useEffect, useState } from "react";
import Api from "../../../Services/Api";

const FALLBACK_BANNERS = [
  {
    id: "fallback-store-banner",
    url: "/Banner-Store.jpg",
    alt: "Banner da Store Smart Olfativos",
  },
];

const StoreHeroBanner = () => {
  const [banners, setBanners] = useState(FALLBACK_BANNERS);
  const [activeBanner, setActiveBanner] = useState(0);

  useEffect(() => {
    let mounted = true;

    const loadBanners = async () => {
      try {
        const response = await Api.get("/public/store-banners");
        const items = Array.isArray(response?.data?.items) ? response.data.items : [];

        if (!mounted || items.length === 0) return;

        setBanners(
          items.map((item, index) => ({
            id: item.id || `store-banner-${index}`,
            url: item.url,
            alt: item.originalName || `Banner da Store ${index + 1}`,
          }))
        );
      } catch (err) {
        console.error("Erro ao carregar banners da store:", err);
      }
    };

    loadBanners();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    setActiveBanner(0);
  }, [banners]);

  useEffect(() => {
    if (banners.length <= 1) return undefined;

    const interval = window.setInterval(() => {
      setActiveBanner((current) => (current + 1) % banners.length);
    }, 5000);

    return () => window.clearInterval(interval);
  }, [banners]);

  return (
    <section className="store-hero">
      <div className="store-hero-banner">
        {banners.map((banner, index) => (
          <div
            key={banner.id}
            className={`store-hero-slide ${index === activeBanner ? "is-active" : ""}`}
          >
            <img src={banner.url} alt={banner.alt} />
          </div>
        ))}

        {banners.length > 1 ? (
          <div className="store-hero-dots">
            {banners.map((banner, index) => (
              <button
                key={`dot-${banner.id}`}
                type="button"
                className={index === activeBanner ? "is-active" : ""}
                aria-label={`Exibir banner ${index + 1}`}
                onClick={() => setActiveBanner(index)}
              />
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default StoreHeroBanner;
